import * as fileTypes from '../types/File';
import * as complaintPositionTypes from '../types/ComplaintPosition';
import * as pageTypes from '../types/Page';
import {HIDE_MODAL} from '../types/Modal';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case fileTypes.FILE_CHANGE_SELECTED_FILE:
            return {
                ...state,
                selectedFile: action.payload
            };
        case fileTypes.FILE_OPEN_FILE_PREVIEW:
            return {
                ...state,
                selectedFile: action.payload
            };
        case HIDE_MODAL:
        case complaintPositionTypes.COMPLAINT_POSITION_ADD_FILE:
        case complaintPositionTypes.COMPLAINT_POSITION_REMOVE_FILE:
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}

const INITIAL_STATE = { 
    selectedFile: null
};


// WEBPACK FOOTER //
// ./src/reducers/File.js